import { Color24, Colors24 } from '@grammarly/badger-ui'

interface WebinarProps {
  color?: Color24
}

export const MicrophoneIcon = (props: WebinarProps) => {
  const { color = 'green60' } = props
  const strokeColor = Colors24[color]
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.2505 9.72295C15.2505 12.6226 12.8998 14.9732 10.0002 14.9732M10.0002 14.9732C7.10061 14.9732 4.75 12.6226 4.75 9.72295M10.0002 14.9732V17.9733M10.0002 17.9733H7.0001M10.0002 17.9733H13.0004M10.0002 11.973C8.75753 11.973 7.75013 10.9656 7.75013 9.72295V5.22275C7.75013 3.98006 8.75753 2.97266 10.0002 2.97266C11.2429 2.97266 12.2503 3.98006 12.2503 5.22275V9.72295C12.2503 10.9656 11.2429 11.973 10.0002 11.973Z"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
